import React, { useContext, useEffect }  from 'react';
import { useNavigate } from "react-router-dom";

import { BsFillPersonLinesFill } from 'react-icons/bs';
import { FaInfoCircle } from 'react-icons/fa';
 import {FaCalendarAlt } from 'react-icons/fa';

import { MdPayment } from 'react-icons/md';

import GlassCard from '../components/UI/GlassCard';
import Perfil from '../components/Perfil';
import FormInfoCard from '../components/FormInfoCard';

import { AppContext } from "../services/AppContext";
import AuthContext from '../context/auth-context';

import useGetDatosPersonales from '../hooks/useGetDatosPersonales';
import useGetContacto from '../hooks/useGetContacto';
import useGetEducacion from '../hooks/useGetEducacion';
import useGetLaboral from '../hooks/useGetExperienciaLaboral';
import useGetPagos from '../hooks/useGetPagos';

import useGetActivacionPagoFormulario from "../hooks/useGetActivacionPagoFormulario";

import useGetFechaAdmisionElegida from "../hooks/useGetFechaAdmisionElegida";

import { MdEdit } from 'react-icons/md';
import useGetAdjuntosdocs from '../hooks/useGetAdjuntosdocs';



function Home() {
    const authContext = useContext(AuthContext);

    const datosPersonales = useGetDatosPersonales(authContext.token);
    const contacto = useGetContacto(authContext.token);
    const educacion = useGetEducacion(authContext.token);
    const laboral   = useGetLaboral(authContext.token);
    const adjuntos   = useGetAdjuntosdocs(authContext.token);




    const pagoAdmision = useGetPagos(authContext.token);
    const fechaAdmisionElegidaData = useGetFechaAdmisionElegida(authContext.token);


    const navigate = useNavigate(); 
    const { appValues, setAppValues } = useContext(AppContext);

    const estadoPago = appValues.pagoAdmision === 'APROBADA' ? 'completado' : 'pendiente'

    const onClickDatosPersonalesHandler = () => {
        return navigate("/informacion-aplicante");
    };

    const onClickPagarAdmisionHandler = () => {
        return navigate("/pago-admision");
    };

    const onClickProgramarExamen = () => {
        return navigate("/programar-admision");
    };

    const onClickShowIntruccionesHandler = () => {
        setAppValues( prev => ({...prev, showInfo: true }) );
    };

    const onClickHideIntruccionesHandler = () => {
        setAppValues( prev => ({...prev, showInfo: false }) );
    };

  //  const estadoInfoAplicante = appValues.infoAplicante ? "completado" : "pendiente";

     //experienciaLaboral
 
    const estadoInfoAplicante = appValues.infoAplicante ? "completado" : "pendiente";
    const estadoexperienciaLaboral = appValues.experienciaLaboral ? "completado" : "pendiente";
   // experienciaLaboral: false;
    const estadoExamenAplicante = appValues.examenAplicante ? "completado" : "pendiente";

   


    /*Agregado para deshabilitar*/

    //let click_pagar_admision_activado = false; //Esta valor debe venir de una llamada de la API (probablemente)
    const click_pagar_admision_activado = useGetActivacionPagoFormulario();
    //console.log(click_pagar_admision_activado);
    let PagarAdmisionClick = false;
    let examenAdmisionClick = false;

    //estadoInfoAplicante
    if((estadoexperienciaLaboral === "completado")){
        examenAdmisionClick = true;
    }

    //estadoInfoAplicante
    if((estadoexperienciaLaboral === "completado") && (estadoExamenAplicante === "completado")){
        PagarAdmisionClick = true;
    }

    
    //En el contexto global debe existir 'examen'
    /*Ya que ahora hay una pestaña extra cada una aumentará el porcentaje en 20%, antes era 25%*/

    useEffect(() => {
        if(datosPersonales !== undefined && "fecha_nacimiento" in datosPersonales && datosPersonales.fecha_nacimiento !== ""){
            setAppValues(
                prev => {
                    let perfil = prev.datosPersonales ? prev.perfil : prev.perfil+20;
                    return { ...prev, datosPersonales: true, perfil };
                }
            );
        }

        if(contacto !== undefined && "direccion" in contacto && contacto.direccion !== ""){
            setAppValues(
                prev => {
                    let perfil = prev.contacto ? prev.perfil : prev.perfil+20;
                    return { ...prev, contacto: true, perfil };
                }
            );
        }

        if(!!educacion && Object.keys(educacion).length > 1){
            setAppValues(
                prev => {
                    let perfil = prev.estudiosSuperiores ? prev.perfil : prev.perfil+20;
                    return { ...prev, estudiosSuperiores: true, perfil };
                }
            );
        }

        if(laboral !== undefined && "trabaja" in laboral &&laboral.trabaja !== ""){
            setAppValues(
                prev => {
                    let perfil = prev.experienciaLaboral ? prev.perfil : prev.perfil+20;
                    return { ...prev, experienciaLaboral: true, perfil };
                }
            );
        }


        if(adjuntos !== undefined && "identificacion" in adjuntos && adjuntos.identificacion !== ""
            && "curriculum" in adjuntos && adjuntos.curriculum !== ""
            && "recomendacion" in adjuntos && adjuntos.recomendacion !== ""
            && "recomendacion2" in adjuntos && adjuntos.recomendacion2 !== ""
            && "titulo" in adjuntos && adjuntos.titulo !== ""
            && "historialnotas" in adjuntos && adjuntos.historialnotas !== ""
        ){
            setAppValues(
                prev => {
                    let perfil = prev.documentosAdjuntos ? prev.perfil : prev.perfil+20;
                    return { ...prev, documentosAdjuntos: true, perfil };
                }
            );
        }


        if(pagoAdmision !== undefined && pagoAdmision.PAGOS ){

            let estadoPagoAdmision = '';
            pagoAdmision.PAGOS.every(pago => {
                if(pago.ESTADO === "APROBADA"){
                    estadoPagoAdmision = pago.ESTADO;
                    return false;
                }
                return true;
            });

            setAppValues(
                prev => {
                    return {...prev, pagoAdmision: estadoPagoAdmision};
                }
            );
        }

        if
        (
            datosPersonales !== undefined && "fecha_nacimiento" in datosPersonales && datosPersonales.fecha_nacimiento !== "" &&
            contacto !== undefined && "direccion" in contacto && contacto.direccion !== "" &&
            educacion !== undefined && Object.keys(educacion).length > 1 &&
            laboral !== undefined && "trabaja" in laboral &&laboral.trabaja !== "" &&
            adjuntos !== undefined && "identificacion" in adjuntos && adjuntos.identificacion !== ""
            && "curriculum" in adjuntos && adjuntos.curriculum !== ""
            && "recomendacion" in adjuntos && adjuntos.recomendacion !== ""
            && "recomendacion2" in adjuntos && adjuntos.recomendacion2 !== ""
            && "titulo" in adjuntos && adjuntos.titulo !== ""
            && "historialnotas" in adjuntos && adjuntos.historialnotas !== ""
        )
        {
            setAppValues(
                prev => {
                    return { ...prev, infoAplicante: true};
                }
            );
        } else {
            setAppValues(
                prev => {
                    return { ...prev, infoAplicante: false};
                }
            );
        }

        //Agregando para el estado del examén de admisión

        
        if
        (
            fechaAdmisionElegidaData !== undefined && "fecha_admision_elegida" in fechaAdmisionElegidaData && fechaAdmisionElegidaData.fecha_admision_elegida !== ""
        )
        {
            
            setAppValues(
                prev => {
                    return { ...prev, examenAplicante: true};
                }
            );
        }else {
            setAppValues(
                prev => {
                    return { ...prev, examenAplicante: false};
                } 
            );
        }





    }, [
        datosPersonales, contacto, educacion, laboral, adjuntos, pagoAdmision, fechaAdmisionElegidaData, setAppValues
    ]);

    //Es necesario colocar otro useEffect, en el que se tome en cuenta la fecha del examen de admisión

    return (
        <GlassCard>
            <div className="row">

                <div className="col-lg-3 pe-0">
                    <Perfil/>
                </div>

                <div className="col-lg-9 px-5">
                    <div className="container py-3"> 
                        <div className="row">
                            <div className="col-lg-12 px-5">

                                {/* INSTRUCCIONES */}
                                <div className="row">
                                    <div className="col-lg-12 pt-3">
                                        {
                                            !appValues.showInfo &&
                                            <button className="btn btn-sm btn-warning alert alert-warning py-2 px-3 mb-0 shadow" onClick={onClickShowIntruccionesHandler}>
                                                <h1 className="display-6 mb-0" style={{fontSize: '1.1rem', userSelect: 'none'}} ><FaInfoCircle/> Instrucciones</h1>
                                            </button>
                                        }
                                        {
                                            appValues.showInfo &&
                                            <div className="alert alert-warning alert-dismissible fade show shadow" role="alert">
                                                <h1 className="display-6" style={{fontSize: '1.5rem', userSelect: 'none'}}><FaInfoCircle/> Instrucciones</h1>
                                                <ul style={{textAlign: 'justify', userSelect: 'none'}}>
                                                    <li>
                                                        <p>Usted deberá ingresar la información que se le solicita. Ponga mucha atención a los mensajes de cada sección, para evitar problemas con el ingreso de la misma.</p>
                                                    </li>
                                                    <li>
                                                        <p>Deberá completar en la información que se le solicita en los formularios, a fin de programar la entrevista de admisión, lo mismo que  para cancelarlo posteriormente vía online,  o personalmente en el Banco Industrial de la UFM, si así lo desea.</p>
                                                    </li>
                                                    <li>
                                                        <p>Para poder pagar y asignarse una fecha para su entrevista usted necesita primero ingresar sus datos personales.
                                                        El proceso de admisión culmina con la entrevista. Si ha sido admitido deberá recibir una carta de admisión por correo electrónico.
                                                        </p>
                                                    </li>

                                                 
                                                </ul>
                                                <button 
                                                    type="button" 
                                                    className="btn-close" 
                                                    data-bs-dismiss="alert" 
                                                    aria-label="Close"
                                                    onClick={onClickHideIntruccionesHandler}></button>
                                            </div>
                                        }
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-lg-12">
                                        <FormInfoCard 
                                            estado={estadoInfoAplicante}
                                            titulo="Información de aplicante"
                                            texto="Debe ingresar toda la información que se le pide. La misma nos servirá para darle seguimiento al correspondiente proceso de admisión,  donde le confirmaremos si ha sido admitido en la unidad académica." 
                                            icon={BsFillPersonLinesFill}
                                            className="my-3" 
                                            disabled={!appValues.infoAplicanteEnabled}
                                            onClick={onClickDatosPersonalesHandler} 
                                            onHover={true} />
                                    </div>

                                    {/* onClick={!DatosPersonalesClick ? () => {} : onClickHandlerDatosPersonales}
                                    onClick={onClickPagarAdmisionHandler}
                                    */}

                                <div className="col-lg-6">
                                        <FormInfoCard 
                                        estado={estadoExamenAplicante}
                                        titulo="Programar examen de admisión"
                                        texto=""
                                        icon={FaCalendarAlt}
                                       // disabled={true}
                                       onClick={!examenAdmisionClick ? () => {} : onClickProgramarExamen}
                                       onHover={true}
                                        className="my-3" />
                                    </div>

                                    <div className="col-lg-6">
                                        <FormInfoCard 
                                        estado={estadoPago} 
                                        titulo="Pago de examen de admisión" 
                                        texto=""
                                        className="my-3"
                                        icon={MdPayment}
                                        onClick={!PagarAdmisionClick ? () => {} : onClickPagarAdmisionHandler}
                                        onHover={true} />
                                    </div>
                                    {/* <div className="col-lg-6">
                                        <FormInfoCard 
                                        estado="pendiente"
                                        titulo="Programar examen de admisión"
                                        texto=""
                                        icon={FaCalendarAlt}
                                        disabled={true}
                                        className="my-3" />
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </GlassCard>
    )
}

export default Home